// extracted by mini-css-extract-plugin
module.exports = {"DeliveryOrders":"DeliveryOrders_DeliveryOrders__oj_Bg"};